import { ofType } from 'redux-observable';
import { of, merge } from 'rxjs';
import { mergeMap, switchMap, catchError } from 'rxjs/operators';

// import axios from '../../utilities/axios';

import { getIp, getIpCompleted, getIpFailed } from './telemetrySlice';

export const getIpEpic = (action$) =>
	action$.pipe(
		ofType(getIp.type),
		mergeMap(async () => {
			// const response = await axios.get('https://geolocation-db.com/json/');

			// if (response.status !== 200) {
			// 	throw new Error(response.message);
			// }

			// return response.data;
			return null;
		}),
		switchMap((res) => [getIpCompleted(res)]),
		catchError((error, source) => merge(of(getIpFailed(error.message)), source))
	);

export default [getIpEpic];
